import FeatureGates, { type GetExperimentValueOptions } from '@atlaskit/feature-gate-js-client';

/**
 * Read a boolean parameter for a Statsig experiment.
 *
 * This is a local copy of the helper used by other growth packages (see
 * `cross-join-nudges`) rather than `@atlaskit/tmp-editor-statsig/expVal`, which
 * is editor-only: it requires the experiment to be registered in the editor
 * experiments config and reads overrides from the editor's own setup, so a
 * standard local Statsig override is never reflected for non-editor packages.
 *
 * Returns `defaultValue` when the Statsig client has not finished initializing
 * (e.g. before the experiment is served to the client).
 */
export const expVal = (
	experimentName: string,
	experimentParam: string,
	defaultValue: boolean,
	options: GetExperimentValueOptions<boolean> = {},
): boolean => {
	if (!FeatureGates.initializeCompleted()) {
		return defaultValue;
	}

	// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
	return FeatureGates.getExperimentValue(experimentName, experimentParam, defaultValue, options);
};
